/* ============ SEASON ONE VEHICLE FILES ============
   Owner-supplied canon content (2026-09-23). Season One only.
   Structure per vehicle: THE MACHINE / THE BUILD / THE ABILITY / THE STORY.
   Do not add specs or capabilities beyond what is written here. */
export const VEHICLE_FILES = [
  { slug: "shadrach", name: "SHADRACH", tag: "SPEED · PRECISION · CROWN SPLIT",
    image: "/assets/art/fleet-shadrach-full.jpg",
    machine: [
      "Platform: 2010 Lamborghini Murciélago LP670-4 SV.",
      "Driver: Chase Alexander Michaels — Cam.",
      "Engine: 6.5L naturally aspirated V12. Factory output: 661 hp / 487 lb-ft.",
      "Factory performance: approximately 0–60 mph in 3.0 seconds; 209–213 mph depending on aerodynamic configuration.",
    ],
    build: [
      "Shadrach communicates with Cam through the same integrated TRINITY network that follows him across his connected technology.",
      "Cam remains the driver and the decision-maker. Shadrach is never an autonomous car.",
    ],
    ability: [
      "CROWN SPLIT — Season One signature system. When Spirit Mode tells Cam “Crown Split,” Cam locks the fleeing target and activates the sequence. TRINITY confirms target lock and initiates a seven-second transformation and launch sequence.",
      "Dashboard seams and floor channels illuminate. Interior structures move clear of the launch channel. Structural side bracing engages. Cam's Etching — his armor formation — occurs while he is still driving.",
      "The windshield illuminates along its center seam. The left and right front body sections unlock. The windshield splits down the center and peels outward with the corresponding front sections, and Shadrach's nose opens into a Y-shaped launch aperture.",
      "TRINITY locks the launch structure and trajectory. Once Cam is fully sealed in the CHERUBIM armor, Shadrach fires him through the center aperture like a cannon shot toward the locked target — and TRINITY continues impact timing while Cam is airborne.",
      "The car itself becomes Cam's launch platform while his armor manifests around him.",
    ],
    story: [
      "Shadrach is the fastest and most precision-oriented member of Cam's furnace trio. Its purpose is controlled speed, pursuit, interception, and urgent response — not brute force.",
    ] },
  { slug: "meshach", name: "MESHACH", tag: "AGILITY · ACCESS · THRESHOLD READ · DARKRIDE · ADAPTIVE STABILIZATION",
    image: "/assets/art/fleet-meshach-full.jpg",
    machine: [
      "Platform: modified Ducati Diavel V4.",
      "Rider: Cam.",
      "Engine: 1,158cc V4 — 168 hp, 93 lb-ft of torque.",
      "Wet weight: approximately 553 lb in the established build profile.",
      "Appearance: black and deep metallic purple sport-cruiser with restrained gold detailing. Aggressive staggered stance — comparatively narrow front, extremely wide and deep rear tire.",
    ],
    build: [
      "Meshach is built around rider-machine precision. Every system aboard is advisory — there is no autopilot. Cam chooses.",
    ],
    ability: [
      "THRESHOLD READ — TRINITY analyzes closing gaps, traffic, obstacles, loading docks, narrow passages, and available routes, then gives Cam timing and clearance information. It is advisory, not autopilot. Cam chooses whether to take the opening.",
      "ADAPTIVE STABILIZATION — Meshach reads road surface, pitch, wheel load, suspension travel, anticipated landing, rider pressure, and lean, then dynamically adjusts damping, preload, and response. It helps the motorcycle respond to Cam's line; it does not magically rescue a bad decision.",
      "DARKRIDE — near-silent, near-dark low-signature operation. Practical lighting and sound are suppressed so Cam can move through the city with minimal signature. Hard acceleration breaks stealth.",
      "TACTICAL LIGHTING — the gold spine and seam can wake during committed maneuvers, with restrained purple and red rear illumination.",
    ],
    story: [
      "Meshach is the fleet's high-speed pursuit, access, and maneuverability machine. It goes where the larger vehicles cannot.",
      "DARKRIDE = disappear. THRESHOLD READ = find the way through. ADAPTIVE STABILIZATION = help Cam survive the way through.",
      "Cam is the indispensable fourth component. The machine calculates. The rider decides.",
    ] },
  { slug: "abednego", name: "ABEDNEGO", tag: "MUSCLE · CONTROL · ROADLOCK · REBUKE MODE",
    image: "/assets/art/fleet-abednego-full.jpg",
    image2: "/assets/art/fleet-abednego-street.jpg",
    machine: [
      "Platform: 1966 Chevrolet Chevelle SS.",
      "Driver: Cam.",
      "Base architecture: classic Mark IV big-block V8. Cam's car is a built, blown big-block — a heavily modified classic muscle car that remains physically believable.",
    ],
    build: [
      "Abednego is the heavy member of the trio: muscle, traction, protection, blocking, impact control, and evacuation-lane support.",
    ],
    ability: [
      "ROADLOCK — traction and road-control architecture. It helps Abednego put its considerable power down, maintain stability, and hold the road under extreme load. Cam remains the driver.",
      "REBUKE MODE — Season One's major Abednego reveal. The vehicle emits a non-lethal concussive sonic pulse. The shockfront carries visible geometric scripture and gold-vector patterns outward like a struck chord made visible.",
      "Rebuke knocks attackers off their feet, scatters and disorients them without permanently maiming them. It is explicitly not an explosion.",
    ],
    story: [
      "Season One uses Abednego as the machine Cam chooses when he needs to act but does not trust himself to wear the Covenant Armor.",
      "Rebuke lets Cam protect someone without putting on the CHERUBIM armor — reinforcing that the man, not the suit, is the hero.",
    ] },
  { slug: "jericho", name: "JERICHO", tag: "FORCE · UTILITY · SERVICE",
    image: "/assets/art/fleet-jericho-full.jpg",
    machine: [
      "Platform: 1970 red-and-white Ford pickup.",
      "Driver: Cam / Initiative use.",
    ],
    build: [
      "Utility, service, hauling, rough-ground movement, and discreet local transportation.",
    ],
    ability: [
      "None — deliberately. Jericho carries no weapons and no superhero abilities. Its strength is that it is useful.",
    ],
    story: [
      "Jericho is deliberately different from the furnace trio. It gives Cam an ordinary Memphis workhorse when arriving in a Lamborghini, a tactical motorcycle, or a purple Chevelle would attract the wrong attention.",
      "Season One uses Jericho for discreet movement rather than chase spectacle.",
    ] },
  { slug: "almer", name: "ALMER", tag: "LEGACY · PRESENCE · PURPOSE",
    image: "/assets/art/fleet-almer-full.jpg",
    machine: [
      "Platform: 2006 Rolls-Royce Phantom — the white Phantom of the Almer Estate.",
    ],
    build: [
      "Preserved as Elijah Almer kept it. It carries no tactical systems.",
    ],
    ability: [
      "None. Its power is presence.",
    ],
    story: [
      "The estate Phantom is a vehicle of legacy and ceremony — left to Cam as part of his inheritance.",
      "It is separate from Monk's black Rolls-Royce, Eulogy. One is inheritance. The other is rank.",
    ] },
  { slug: "old-man", name: "OLD MAN", tag: "PRESERVATION · CLASS · PURPOSE",
    image: "/assets/art/fleet-oldman-full.jpg",
    machine: [
      "Platform: gold 1995 Mercedes-Benz coupe.",
      "Owner/Driver: Almer legacy / Cam.",
      "Status: preserved and non-weaponized.",
    ],
    build: [
      "It carries no codename, no armor link, and no tactical systems.",
    ],
    ability: [
      "None — it is not tactical, magical, armor-linked, or a chase vehicle.",
    ],
    story: [
      "It sits apart from the furnace trio in The Overlook garage. It represents beauty, memory, inheritance, and restraint.",
      "Sometimes Cam chooses the car that does not announce that he is arriving for war.",
    ] },
  { slug: "vampire", name: "VAMPIRE", tag: "MONK'S CORVETTE",
    image: "/assets/art/fleet-vampire.jpg",
    machine: [
      "Platform: red Corvette Z06.",
      "Owner/Driver: Monk.",
    ],
    build: [
      "Fast, aggressive, stylish, and dangerous — carrying the established COFFIN sound-system identity.",
    ],
    ability: [
      "No tactical systems. Vampire's threat is the man behind the wheel.",
    ],
    story: [
      "Vampire is Monk's road presence — the natural counterpoint to Cam's vehicles.",
      "In Season One it becomes sacrificial rather than merely glamorous: the Corvette is damaged and sacrificed while protecting Noah and creating an escape lane.",
    ] },
  { slug: "eulogy", name: "EULOGY", tag: "MONK'S BLACK ROLLS-ROYCE PHANTOM",
    image: "/assets/art/fleet-eulogy.jpg",
    machine: [
      "Platform: black Rolls-Royce Phantom.",
      "Owner: Monk.",
    ],
    build: [
      "A luxury and authority vehicle — not a pursuit machine.",
    ],
    ability: [
      "None. Eulogy carries no tactical systems.",
    ],
    story: [
      "Eulogy communicates Monk's status and power. Vampire is the aggressive road car; Eulogy is the statement of rank.",
    ] },
  { slug: "goliath", name: "GOLIATH", tag: "HARLAN'S COMMAND VEHICLE",
    image: "/assets/art/fleet-goliath.jpg",
    image2: "/assets/art/fleet-goliath-rear.jpg",
    machine: [
      "Platform: 2023 Cadillac Escalade-V.",
      "Owner: Colonel Richard Harlan.",
      "Factory engine: supercharged 6.2L V8 — 682 hp, 653 lb-ft of torque.",
      "Transmission: 10-speed automatic. Drivetrain: full-time active all-wheel drive.",
      "Factory 0–60 mph: under 4.4 seconds.",
    ],
    build: [
      "Configured for command, observation, and control — tied into Harlan's surveillance and command network.",
    ],
    ability: [
      "No offensive weapons. Goliath's power is information and oversight.",
    ],
    story: [
      "Goliath is not another hero pursuit car. It is the mobile seat of Harlan's command — watching, directing, controlling.",
    ] },
  { slug: "heaven", name: "HEAVEN", tag: "HOPE CENTER VAN",
    image: "/assets/art/fleet-heaven.jpg",
    image2: "/assets/art/fleet-heaven-hope-center.jpg",
    machine: [
      "A practical church van.",
      "Owner: Pastor Wei Chen / Hope Center.",
    ],
    build: [
      "Shelter, rescue, human cargo. Nothing more — and nothing less.",
    ],
    ability: [
      "None. HEAVEN is not weaponized.",
    ],
    story: [
      "HEAVEN is not part of Almer's tactical furnace fleet. It is emotionally important precisely because it is an ordinary community vehicle.",
      "It is the vehicle associated with Chen bringing Cam home after IronVale, and it remains important during rescue and evacuation work — moving people safely.",
    ] },
];
